let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("5oU5X"), load("2F69B"), load("hhss7"), load("9g1FS")]).then(() => parcelRequire('4GncZ'));